module.exports = __webpack_public_path__ + "static/media/bg40.e2b46597.jpg";